import { Tool } from './base'

export class CorelightInvestigatorTool extends Tool {
  public readonly toolName = 'Corelight Investigator'
  // NDR is a network-detection log aggregator; routed through the matrix path alongside SIEMs.
  public readonly toolKind = 'ndr' as const

  // generateSearchPermalink(rootURL: string, renderedContent: string): string {
  //   const encodedRenderedContent = encodeURIComponent(renderedContent);
  //   return `${rootURL}investigate/events/en-US/app/eam2/search?q=${encodedRenderedContent}`;
  // }
}
